import { Injectable } from '@angular/core';
import { RBS_TOKEN } from '../../multi-stage-assignment-report/store/multi-stage-assignment-report.model';
import { environment } from './../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class StorageService {

    getItem(key: string): any {
        if (sessionStorage.getItem(this.normalized(key)) !== 'undefined') {
            return JSON.parse(sessionStorage.getItem(this.normalized(key)));
        }
        return null;
    }

    setItem(key: string, value: any): void {
        sessionStorage.setItem(this.normalized(key), JSON.stringify(value));
    }

    removeItem(key: string): void {
        sessionStorage.removeItem(this.normalized(key));
    }

    clear(): void {
        Object.keys(sessionStorage)
            .filter((key) => key.includes(environment.appId))
            .forEach((item) => sessionStorage.removeItem(item));
    }

    private normalized(key: string): string {
        return `${environment.appId}-${key}`;
    }

    isValidItem(key: string): boolean {
        return sessionStorage.getItem(this.normalized(key)) !== 'undefined';
    }

    getRealizeRbsToken(): any {
        return JSON.parse(sessionStorage.getItem(RBS_TOKEN));
    }

    clearRealizeRbsToken(): void {
        sessionStorage.removeItem(RBS_TOKEN);
    }
}
